import React from 'react';
import { DishFirstFoodItemsSegmentFragment } from 'src/gqlReactTypings.generated.d';
import {
  SegmentHeaderContainer,
  SegmentHeaderRow,
  SegmentHeaderSubtitle,
  SegmentHeaderTitle,
} from 'src/pages/consumer/dish-first/explore/styles';
import { Header, SeeAllButton } from '../styles';

interface IProps {
  className?: string;
  segment: DishFirstFoodItemsSegmentFragment;
  showSeeAllButton?: boolean;
  handleSeeAllButtonClick: () => void;
}

export const ShefSegmentHeader: React.FC<IProps> = ({
  className,
  segment,
  showSeeAllButton = true,
  handleSeeAllButtonClick,
}): JSX.Element => (
  <SegmentHeaderContainer className={className}>
    <SegmentHeaderRow>
      <Header>
        <SegmentHeaderTitle>{segment.displayName}</SegmentHeaderTitle>
      </Header>

      {showSeeAllButton && segment.id !== 'ALL' && (
        <SeeAllButton onClick={handleSeeAllButtonClick}>See all</SeeAllButton>
      )}
    </SegmentHeaderRow>
    {segment.subtitle && (
      <SegmentHeaderRow>
        <SegmentHeaderSubtitle>{segment.subtitle}</SegmentHeaderSubtitle>
      </SegmentHeaderRow>
    )}
  </SegmentHeaderContainer>
);
